module.exports = __webpack_public_path__ + "static/logo-b4eb8cb033203fdd677f048fd4248c26.png";